<template>
  <v-dialog :value="value" max-width="1000" persistent @input="$emit('input', $event)">
    <v-card :loader-height="2">
      <v-card-text class="tableHeaderBg d-flex align-center py-2 px-4">
        <span class="font-size-md">File Config View</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" class="ml-2" data-testid="config-view-dialog__close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text>
        <div class="font-size-md mb-2">Configuration Summary:</div>

        <!-- Basic Details -->
        <h4 class="font-weight-medium mb-4">Basic Details</h4>
        <div class="mb-4">
          <div class="font-weight-bold">
            File Name :
            <span class="font-weight-regular">{{ config.file }}</span>
          </div>
          <div class="font-weight-bold">
            Ignore Rows :
            <span class="font-weight-regular">{{ config.ignorerows }}</span>
          </div>
          <div class="font-weight-bold">
            Ignore Column :
            <span class="font-weight-regular">{{ config.ignorecolumns }}</span>
          </div>
        </div>

        <!-- Column Mapping -->
        <h4 class="font-weight-medium mb-3">Column Mapping</h4>
        <div class="d-flex">
          <div>
            <div
              v-for="(fileCol, i) in config.columnmap"
              :key="i"
              class="my-1"
            >
              <div class="d-flex align-center">
                <v-chip label class="flex-grow-1" outlined color="primary">
                  <span>{{ fileCol[0] }}</span>
                </v-chip>
                <div style="width: 50px">
                  <v-divider></v-divider>
                </div>
                <div
                  class="drag-droppable py-1 px-2 blue-grey lighten-5"
                  style="min-width: 200px; border: 2px dashed #ccc"
                >
                  <div class="d-flex justify-center">
                    <span v-html="fileCol[1] || '&nbsp;'"></span>
                    <v-spacer></v-spacer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- User Column Mapping -->
        <h4 class="font-weight-medium mb-3 mt-4">User Column Mapping</h4>
        <div class="d-flex">
          <div>
            <div
              v-for="(fileCol, i) in config.usercolumnmap"
              :key="i"
              class="my-1"
            >
              <div class="d-flex align-center">
                <v-chip label class="d-block flex-grow-1" outlined color="primary">
                  <span>{{ fileCol[1] }}</span>
                </v-chip>
                <div style="width: 50px">
                  <v-divider></v-divider>
                </div>
                <div
                  class="drag-droppable py-1 px-2 blue-grey lighten-5"
                  style="min-width: 200px; border: 2px dashed #ccc"
                >
                  <div class="d-flex justify-center">
                    <span v-html="fileCol[0] || '&nbsp;'"></span>
                    <v-spacer></v-spacer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Removed Columns -->
        <div class="mb-2 mt-2">
          <h4 class="font-weight-medium mb-4">Removed Columns</h4>
          <v-chip
            v-for="(a, b) in (config || {}).ignoredcolumns"
            :key="b"
            class="ma-1"
            label
            text-color="primary"
            color="blue-grey lighten-5"
          >
            <span>{{ a }}</span>
          </v-chip>
        </div>

        <!-- Create Columns -->
        <div class="mb-2 mt-2">
          <h4 class="font-weight-medium mb-4">Create Columns</h4>
          <v-chip
            v-for="(colum, i) in config.unusedcolumns"
            :key="'C' + i"
            class="ma-1"
            label
            text-color="primary"
            color="blue-grey lighten-5"
          >
            <span>{{ colum }}</span>
          </v-chip>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfigViewDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>
